import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { C, STATES, JOURNEYS } from "../data/content";

const API = process.env.REACT_APP_BACKEND_URL;

export const RegistrationForm = ({ attribution, idPrefix = "hero", showBonuses = true }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "", phone: "", state: "", journey: "" });
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!consent) { setError("Please check the consent box to register."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/ghl-lead`, {
        ...form,
        journey: form.journey || null,
        consent: true,
        consentText: C.consentText,
        consentTimestamp: new Date().toISOString(),
        ...attribution,
      });
      navigate("/thank-you");
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
      setBusy(false);
    }
  };

  return (
    <div className="glass-card p-6 md:p-7" data-testid={`${idPrefix}-registration-card`}>
      {showBonuses && (
        <>
          <p className="mono text-[10px] tracking-[0.3em] text-[var(--accent)] mb-2">DON'T MISS OUT</p>
          <h3 className="text-base font-black uppercase mb-4">When You Register, You'll Receive:</h3>
          <ul className="space-y-2 mb-4">
            {C.bonuses.map((b, i) => (
              <li key={i} className="flex gap-2.5 text-[12.5px] text-white/70 leading-snug">
                <span className="text-[var(--accent)] font-black shrink-0">✓</span>{b}
              </li>
            ))}
          </ul>
          <p className="text-[22px] font-black text-[var(--accent)] mb-5">FREE!</p>
        </>
      )}
      <form onSubmit={submit} className="space-y-3" data-testid={`${idPrefix}-registration-form`}>
        <div className="grid grid-cols-2 gap-3">
          <input required className="field" placeholder="First name" value={form.firstName} onChange={set("firstName")} data-testid={`${idPrefix}-first-name-input`} />
          <input required className="field" placeholder="Last name" value={form.lastName} onChange={set("lastName")} data-testid={`${idPrefix}-last-name-input`} />
        </div>
        <input required type="email" className="field" placeholder="Email address" value={form.email} onChange={set("email")} data-testid={`${idPrefix}-email-input`} />
        <input required type="tel" className="field" placeholder="Mobile phone" value={form.phone} onChange={set("phone")} data-testid={`${idPrefix}-phone-input`} />
        <select required className="field" value={form.state} onChange={set("state")} data-testid={`${idPrefix}-state-select`}>
          <option value="" disabled>State</option>
          {STATES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <select className="field" value={form.journey} onChange={set("journey")} data-testid={`${idPrefix}-journey-select`}>
          <option value="">Where are you in your homebuying journey? (optional)</option>
          {JOURNEYS.map((j) => <option key={j} value={j}>{j}</option>)}
        </select>
        <label className="flex gap-2.5 items-start cursor-pointer">
          <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[#444CE7]" data-testid={`${idPrefix}-consent-checkbox`} />
          <span className="text-[10px] leading-relaxed text-white/35">{C.consentText}</span>
        </label>
        {error && <p className="text-xs text-red-400" data-testid={`${idPrefix}-form-error`}>{error}</p>}
        <button type="submit" disabled={busy} className="btn-accent w-full cta" data-testid={`${idPrefix}-submit-button`}>
          {busy ? "RESERVING..." : "✓ RESERVE MY FREE SEAT"}
        </button>
        <p className="text-[10px] text-white/25 text-center">{C.microTrust}</p>
      </form>
    </div>
  );
};
